import { SecurityRegistryRecord } from "./security-registry-record";

export class SecurityHoldingValidationError {
  static readonly $type: string;
  holdersRelationshipIds: string[];
  message: string;
  $type: string;

  constructor(props: Partial<SecurityHoldingValidationError> = {}) {
    this.$type = (this.constructor as typeof SecurityHoldingValidationError).$type;
    this.holdersRelationshipIds = props.holdersRelationshipIds ?? [];
    this.message = props.message ?? '';
  }

  static createSecurityHoldingValidationError(validationError: SecurityHoldingValidationError): SecurityHoldingValidationError {
    switch (validationError.$type) {
      case SecurityHoldingValidationErrorMinusHistoricalBalance.$type:
        return new SecurityHoldingValidationErrorMinusHistoricalBalance(validationError);
      case SecurityHoldingValidationErrorMinusCurrentBalance.$type:
        return new SecurityHoldingValidationErrorMinusCurrentBalance(validationError);
      default:
        throw new Error(`Unknown change data type: ${ validationError.$type }`);
    }
  }

  static getMessage(record: SecurityRegistryRecord): string {
    const holdersNames = record.holders.map((holder) => holder.name).join(', ');
    return `Security Holding Validation Error for ${ holdersNames }`;
  }
}

export class SecurityHoldingValidationErrorMinusHistoricalBalance extends SecurityHoldingValidationError {
  static override $type = 'SecurityHoldingValidationErrorMinusHistoricalBalance';

  transactionIds: string[];

  constructor(data: Partial<SecurityHoldingValidationErrorMinusHistoricalBalance> = {}) {
    super(data);

    this.transactionIds = data.transactionIds ?? [];
  }

  static override getMessage(record: SecurityRegistryRecord): string {
    const holdersNames = record.holders.map((holder) => holder.name).join(', ');
    return `Negative historical balance ${ holdersNames }`;
  }
}

export class SecurityHoldingValidationErrorMinusCurrentBalance extends SecurityHoldingValidationError {
  static override $type = 'SecurityHoldingValidationErrorMinusCurrentBalance';

  number: number;
  paid: number;
  unpaid: number;

  constructor(data: Partial<SecurityHoldingValidationErrorMinusCurrentBalance> = {}) {
    super(data);

    this.number = data.number ?? 0;
    this.paid = data.paid ?? 0;
    this.unpaid = data.unpaid ?? 0;
  }

  static override getMessage(record: SecurityRegistryRecord): string {
    const holdersNames = record.holders.map((holder) => holder.name).join(', ');
    return `Negative current balance ${ holdersNames }`;
  }
}
